import { Pipe, PipeTransform } from '@angular/core';

export enum EntityType {
  OSOBA_FIZYCZNA = '14115421-88f2-431a-8310-203c68180b33',
  OSOBA_PRAWNA = '8172a696-2a3b-402a-b262-dfcf37404da3'
}

export function getEntityTypeNameById(v: string): string {
  switch (true) {
    case v === EntityType.OSOBA_FIZYCZNA: {
      return 'Osoba fizyczna';
    }
    case v === EntityType.OSOBA_PRAWNA: {
      return 'Osoba prawna';
    }
    default:
      return '';
  }
}

@Pipe({
  name: 'entityType',
  standalone: true
})
export class EntityTypePipe implements PipeTransform {
  public transform(v: string): string {
    return getEntityTypeNameById(v);
  }
}
